export const teamsData = [{
    id: 'engineering-1001',
    department: 'Engineering',
    platform: [{
        id: 'product-engineering-1001',
        name: 'Product Engineering',
        jobsList: [{
            id: '10001',
            location: 'Bangalore',
            job_name: 'Software Lead - Web (5+ yrs)',
        }, {
            id: '10003',
            location: 'Bangalore',
            job_name: 'Software Engineer / Sr. Software Engineer - WEB  (1+ yrs)',
        },{
            id: '10002',
            location: 'Bangalore',
            job_name: 'Software Engineer / Sr. Software Engineer - Android (1+ yrs)',
        },
            {
                id: '10004',
                location: 'Bangalore',
                job_name: 'Software Lead - iOS (5+ yrs)',
            },
            {
                id: '10005',
                location: 'Bangalore',
                job_name: 'Software Engineer / Sr. Software Engineer - iOS (1+ yrs)',
            },{
                id: '10051',
                location: 'Bangalore',
                job_name: 'Backend Developer (Django + MongoDB)',
            }]
    }, /*{
        name: 'QA Engineering',
        jobsList: [{
            id: '10004',
            location: 'Bangalore',
            job_name: 'QA Engineering test 01',
            url: 'qa-engineering-test-01',
        }, {
            id: '10005',
            location: 'Bangalore',
            job_name: 'QA Engineering test 02',
            url: 'qa-engineering-test-02',
        }]
    }*/]
},{
        id: 'sales-1001',
        department: 'Sales',
        platform: [{
            id: 'sales-1008',
            name: 'Business solutions',
            jobsList: [{
                id: '100013',
                location: 'Bangalore',
                job_name: 'Sales Manager (3+ yrs)',
            }]
        }]
    },
    {
        id: 'business-1001',
        department: 'Operations',
        platform: [{
            id: 'sales-1007',
            name: 'Business solutions',
            jobsList: [{
                id: '100012',
                location: 'Bangalore',
                job_name: 'Operations Executive (1+ yrs | 2 Positions)',
            }]
        }]
    }];



// WEBPACK FOOTER //
// ./src/data/teamsData.js